import { computed } from "vue";

export default {
  // notice: please use with SimpleInputMixin!
  // mixins: [SimpleInputMixin],
  inheritAttrs: false,
  props: {
    themes: {
      type: [Array],
      default: () => {
        return config.style.weUI.buttonThemes;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    computedTheme() {
      if (typeof this.value === "string") {
        return this.getItemByValue(this.value).color1;
      }

      return "";
    },
    computedTheme2() {
      if (typeof this.value === "string") {
        return this.getItemByValue(this.value).color2;
      }

      return "";
    },
    computedThemeCssValue() {
      if (!this.computedTheme || this.computedTheme === "") {
        return `repeating-conic-gradient(var(--c-gray-2) 0% 25%, var(--c-bg) 0% 50%)
    50%/ 10px 10px`;
      }
      return `var(--c-${this.computedTheme})`;
    },
    internalThemeList() {
      return Object.values(this.themes).map((conf) => ({
        value: conf.value,
        label: `theme.buttonThemes.${conf.value}`,
        color1: conf.color1,
        color2: conf.color2,
      }));
    },
    safeAttrs() {
      let base = { ...this.$attrs };
      delete base.class;
      delete base.validationMessage;
      return base;
    },
  },
  methods: {
    getItemByValue(val) {
      let result = false;

      if (!Array.isArray(this.internalThemeList)) {
        return false;
      }
      this.internalThemeList.forEach((item) => {
        if (item.hasOwnProperty("value") && item.value === val) {
          result = item;
          return false;
        }
      });
      return result;
    },
  },
  created() {},
};
